<template>
  <div v-if="showMessage" class="alert-disp-msg-container">
    <div class="alert-disp-msg-label">
      {{ $t('alert.warningForNotEnablingAI') }}
    </div>
    <div class="alert-disp-msg-btn-container">
      <RexButtonV3
        variant="primary"
        @onClick="navigateToSales"
        id="alert-disp-msg-sales-nav-btn"
      >
        {{ $t('contactSales') }}
      </RexButtonV3>
    </div>
  </div>
</template>

<script>
import RexButtonV3 from '@/rex-components/RexButtonV3.vue';
import getEnv from '@/utils/env';

export default {
  name: 'DisplayMessage',
  components: {
    RexButtonV3,
  },
  props: {
    showMessage: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    navigateToSales() {
      const SS_AIOPS_SALES_PAGE_URL =
        getEnv('VUE_APP_SS_AIOPS_SALES_PAGE') ||
        process.env.VUE_APP_SS_AIOPS_SALES_PAGE ||
        'https://sixthsense.rakuten.com/platform/cognitive-aiops';
      window.open(SS_AIOPS_SALES_PAGE_URL, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.alert-disp-msg-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1rem;
}
.alert-disp-msg-label {
  background-color: rgba($color: $color-brand-accent, $alpha: 0.3);
  padding: 0.3rem 1rem;
  border-left: 3px solid $color-brand-accent;
  color: $color-brand-accent;
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  width: 100%;
  font-size: 14px;
}
.alert-disp-msg-btn-container {
  margin-left: 0.5rem;
  height: 100%;
  padding: 0.3rem;
}
</style>
